import { HttpClient } from "@angular/common/http";
import { Injectable} from "@angular/core";
import {Observable} from "rxjs";
import { map } from "rxjs/operators";
import {
    ActionResult,
    ActionResultList,
    Country,
    EventItem,
    FindEventsRequest,
    PagedFilter,
    RaceRegistration,
    Sport,
    UserEvent,
    UserRegistrationFilter,
    UserStatistics
} from "@model";
import { EnvironmentService } from "./environment.service";
import {WaypointService} from "./waypoint.service";
import {LoaderService} from "./loader.service";

@Injectable({ providedIn: 'root' })
export class UserEventsService {


    constructor(private http: HttpClient, private loaderService: LoaderService,
                private environmentService: EnvironmentService, public waypointService:WaypointService ) {
    }


    addEventToFavorites(eventId: number): Observable<ActionResult<boolean>> {
        const url = `${this.environmentService.getApiUrl()}/api/events/favorite/add`;
        return this.http.post<ActionResult<boolean>>(url, eventId);
    }

    removeEventFromFavorites(eventId: number): Observable<ActionResult<boolean>> {
        const url = `${this.environmentService.getApiUrl()}/api/events/favorite/remove`;
        return this.http.post<ActionResult<boolean>>(url, eventId);
    }


    fetchUserRecommendedEvents(): Observable<EventItem[]> {
        return this.http.get<ActionResultList<EventItem[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/recommended`).pipe(
            map(value => {
                const result = value?.result ?? [];
                return result;
            })
        );
    }

    fetchUserPastEvents(filter: FindEventsRequest): Observable<UserEvent[]> {
        return this.http.post<ActionResultList<UserEvent[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/results`, filter).pipe(
            map(value => {
                const result = value?.result ?? [];
                return result;
            })
        );
    }

    fetchUserRegistrations(filter: PagedFilter<UserRegistrationFilter>): Observable<RaceRegistration[]> {
        return this.http.post<ActionResultList<UserEvent[], number>>(`${this.environmentService.getApiUrl()}/api/user/registrations`, filter).pipe(
            map(value => {
                const result = value?.result ?? [];
                return result;
            })
        );
    }

    fetchUserRegistration(registrationId: number): Observable<RaceRegistration | undefined> {
        return this.http.get<ActionResult<RaceRegistration>>(`${this.environmentService.getApiUrl()}/api/user/registration?registrationId=${registrationId}`).pipe(
            map(value => {
                return value.result;
            })
        );
    }

    filterUserFavoriteEvents(filter: FindEventsRequest): Observable<EventItem[]> {
        return this.http.post<ActionResultList<EventItem[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/favorite/filter`, filter).pipe(
            map(value => {
                const result = value?.result ?? [];
                return result;
            })
        );
    }

    fetchAllUserFavoriteEvents(): Observable<EventItem[]> {
        return this.http.get<ActionResultList<EventItem[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/favorite/all`).pipe(
            map(value => {
                const result = value?.result ?? [];
                return result;
            })
        );
    }


    fetchUserUpcomingEvents(filter: FindEventsRequest): Observable<UserEvent[]> {
        return this.http.post<ActionResultList<UserEvent[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/upcoming`, filter).pipe(
            map(value => {
                const result = value?.result ?? [];
                return result;
            })
        );
    }

    getUserEventsSports(type: UserEventType): Observable<Sport[]> {
        return this.http.get<ActionResultList<Sport[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/${type}/filters/sports`).pipe(
            map(value => value?.result ?? [])
        );
    }

    getUserEventsCountries(type: UserEventType): Observable<Country[]> {
        return this.http.get<ActionResultList<Country[], number>>(`${this.environmentService.getApiUrl()}/api/user/events/${type}/filters/countries`).pipe(
            map(value => value?.result ?? [])
        );
    }

    fetchEntryData(competitorId: number): Observable<UserEvent | undefined> {
        return this.http.get<ActionResult<UserEvent>>(`${this.environmentService.getApiUrl()}/api/user/events/entry?competitorId=${competitorId}`).pipe(
            map(value => {
                return value.result;
            })
        );
    }

    fetchStatistics(year: number): Observable<UserStatistics | undefined> {
        return this.http.post<ActionResult<UserStatistics>>(`${this.environmentService.getApiUrl()}/api/user/statistics`, year).pipe(
            map(value => {
                return value.result;
            })
        );
    }
}


export enum UserEventType {
    UPCOMING = 'upcoming',
    RESULTS = 'results',
    FAVORITE = 'favorite'
}